import Exception403 from './403.vue'

export default Exception403
